import axios from 'axios';
import {
  DayAheadData,
  IntradayData,
  CombinedPriceData,
  AvailableDatesResponse,
  LatestPriceData
} from '../types/price';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

class ApiService {
  private axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  async getDayAheadPrices(date: string): Promise<DayAheadData> {
    const response = await this.axiosInstance.get(`/prices/day-ahead/${date}`);
    return response.data;
  }

  async getIntradayPrices(date: string): Promise<IntradayData> {
    const response = await this.axiosInstance.get(`/prices/intraday/${date}`);
    return response.data;
  }

  async getCombinedPrices(date: string): Promise<CombinedPriceData> {
    const response = await this.axiosInstance.get(`/prices/combined/${date}`);
    return response.data;
  }

  async getAvailableDates(limit?: number, offset?: number): Promise<AvailableDatesResponse> {
    const params = new URLSearchParams();
    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());

    const response = await this.axiosInstance.get(`/prices/available-dates?${params.toString()}`);
    return response.data;
  }

  async getLatestPrices(): Promise<LatestPriceData> {
    const response = await this.axiosInstance.get('/prices/latest');
    return response.data;
  }
}

export default new ApiService();